import styled from 'styled-components';

export const LinkButton = styled.a`
  cursor: pointer;
  display: block;
  text-align: center;
  text-decoration: none;
  padding: 12px 55px;
  border: 1px solid ${({ theme }) => theme.brandTheme.brand100};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  background: ${({ theme }) => theme.brandTheme.brand100};
  color: ${({ theme }) => theme.palette.white};
  p {
    color: ${({ theme }) => theme.palette.white};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.accent100};
    outline-offset: 2px;
  }
`;
